
<div class="flow-timeseries-tooltip">
	<div class="flow-t-tooltip-title">
		{{ formatTitle(title) }}
	</div>
	<div
		v-for="(p, index) in points"
		:key="p.index + p.name + index"
		class="flow-t-tooltip-name-value"
	>
		<span class="flow-t-tooltip-point-name text-ellipsis">{{ p.name }}</span>
		<span class="flow-t-tooltip-point-value" :style="'color:' + p.color">{{ p.value }}</span>
	</div>
</div>
